import { action, makeObservable, observable } from "mobx";
import { IPromiseBasedObservable, fromPromise } from "mobx-utils";
import {  NoteApi, NoteDto } from "../../api-client";
import AuthStore from "../Auth/authStore";
import PatientsStore from "../Patients/patientsStore";
import notificationStore from "../Notification/notificationStore";

export default class NotesStore {
  public apiClient: NoteApi;
  public authStore: AuthStore;
  public patientStore:PatientsStore

  public constructor(apiClient: NoteApi, authStore: AuthStore,patientStore:PatientsStore) {
    makeObservable(this);
    this.apiClient = apiClient;
    this.authStore=authStore;
    this.patientStore=patientStore;
  }
  public fetchNotes:boolean=false;
  public resourceRequest: IPromiseBasedObservable<any> | null = null;

  // @observable
  // public updatedDoctor: CreateDoctorDto | null = null;
  
  // @action
  // public setUpdatedDoctor = (doctor: CreateDoctorDto | null) => {
  //   this.updatedDoctor = doctor;
  //   console.log('UPDATAEDDDOCTOR',this.updatedDoctor?.number)
  // };

public  setFetchNotes= (value:boolean)=>{
  this.fetchNotes=value
}

  public postNotes = async (userId:string,body:NoteDto) => {
    try{
    const { data } = (await this.apiClient.postNote(userId,body)) as any;
    // await this.patientStore.updatePatientData(this.patientStore.filteredPatient as number);
    this.setFetchNotes(!this.fetchNotes)


    return data|| [];}
    catch (error:any) {
      this.resourceRequest = fromPromise.reject(error);
      const errorMessage = error.response.data.message || "Fehler beim Hinzufügen von Notizen!";
      notificationStore.showMessage(errorMessage, "error", error);
      
    }
  };

  public updateNoteById = async (noteId:string,userId:string,body:NoteDto) => {
    try{
    const { data } = (await this.apiClient.updateNote(noteId,userId,{ ...body, id: body.id ?? noteId })) as any;
    // await this.patientStore.updatePatientData(this.patientStore.filteredPatient as number);
    this.setFetchNotes(!this.fetchNotes)


    return data|| [];}
    catch (error:any) {
      this.resourceRequest = fromPromise.reject(error);
      const errorMessage = error.response.data.message || "Fehler beim Aktualisieren der Notizen!";
      notificationStore.showMessage(errorMessage, "error", error);
      
    }
  };

  public deleteNotebyId = async (noteId:string) => {
    try{
    const { data } = (await this.apiClient.deleteNote(noteId)) as any;
    this.setFetchNotes(!this.fetchNotes)
    


    return data|| [];}
    catch (error) {
      this.resourceRequest = fromPromise.reject(error);
      
    }
  };

  public getRxNotes = async (rxId:string) => {
    try{
    const { data } = (await this.apiClient.getRxNotes(rxId)) as any;


    return data|| [];}
    catch (error) {
      this.resourceRequest = fromPromise.reject(error);
      
    }
  };
  public getAppointmentNotes = async (apptId:string) => {
    try{
    const { data } = (await this.apiClient.getAppointmentNotes(apptId)) as any;


    return data|| [];}
    catch (error) {
      this.resourceRequest = fromPromise.reject(error);
      
    }
  };


}
  

